<script setup lang="ts">
const props = defineProps<{
	size: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl';
	noPadding?: boolean;
	noMargin?: boolean;
}>();
</script>

<template>
	<div
		class="container"
		:class="[{
			[`container--${props.size}`]: props.size,
			'container--no-padding': props.noPadding,
			'container--no-margin': props.noMargin,
		}]"
	>
		<slot />
	</div>
</template>

<style scoped lang="scss">
@layer hm-components
{
	.container
	{
		--container-p:var(--spacing-md);
		--container-m:auto;

		width:100%;
		max-width:var(--container-width);
		padding-inline:var(--container-p);
		margin-inline:var(--container-m);

		$container-array: 'xs', 'sm', 'md', 'lg', 'xl', '2xl', '3xl';

		@each $container-value in $container-array
		{
			&--#{$container-value}
			{
				--container-width:var(--container-#{$container-value});
			}
		}

		&--no-padding
		{
			--container-p:0
		}
		&--no-margin
		{
			--container-m:0;
		}
	}
}
</style>
